module.exports = __webpack_public_path__ + "img/vault.cdf7ca02.svg";